import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ISendOtpCodePayload {
    email: string
    eventId?: string
    sagaCB?: {
        onSuccess: any
    }
}

export interface ISendOtpCodeState {
    status: string
    data: {
        token: string
    }
    errors: any
}

const initialState: ISendOtpCodeState = {
    status: STATUS.IDLE,
    data: {
        token: ''
    },
    errors: null
}

const sendOtpCodeSlice = createSlice({
    name: 'auth/send-otp-cpde',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<ISendOtpCodePayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data.token = action.payload.token
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const sendOtpCodeActions = sendOtpCodeSlice.actions
export default sendOtpCodeSlice.reducer
